import { useEffect } from "react";
import { SocketContextProvider } from "./context/SocketContext";
import ChatApp from "./pages/ChatApp";
import { ChatProvider } from "./context/ChatContext";

const App = () => {
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    localStorage.setItem("token", queryParams.get("token") || "");
  }, []);

  const handleMessageEvent = (e: MessageEvent) => {
    switch (e.data.event) {
      case "open_chat":
        if (e.data && e.data.value && e.data.value.chatOpen !== undefined) {
          localStorage.setItem("chat_open", e.data.value.chatOpen);
        } else {
          localStorage.setItem("chat_open", "true");
        }
        localStorage.setItem(
          "chat_window",
          localStorage.getItem("chat_window") || "home"
        );
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleMessageEvent);

    return () => {
      window.removeEventListener("message", handleMessageEvent);
    };
  });

  return (
    <ChatProvider>
      <SocketContextProvider>
        <ChatApp />
      </SocketContextProvider>
    </ChatProvider>
  );
};

export default App;
